export default {
      id: "levelmeter2-usage",
      viewBox: "0 0 12.989 15.974",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#levelmeter2",
      toString: function () {
        return this.url;
      }
    }